import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { extractApiError } from "../api/apiErrorHandler";
import { showToast } from "components/toast";
import { fetchContainer } from "api/containerApi";
import { createContainer } from "api/containerApi";
import { addItemsContainer } from "api/containerApi";
import { fetchContainerDetails } from "api/containerApi";
import { createContainerNo } from "api/containerApi";
import { fetchContainerStatus } from "api/containerApi";
import { fetchOrderItems } from "api/containerApi";
import { assignitemApi } from "api/containerApi";
import { splitContainerItemApi } from "api/containerApi";
import { reverseSplitContainerItemApi } from "api/containerApi";
import { unassignitemApi } from "api/containerApi";
import { changeContainerStatusApi } from "api/containerApi";
import { deleteContainerItemApi } from "api/containerApi";
import { updateContainer } from "api/containerApi";

const initialState = {
  containerData: {},
  containerLoading: false,
  containerError: null,

  createLoading: false,
  createError: null,

  editLoading: false,
  editError: null,

  addContainerLoading: false,
  addContainerError: null,

  containerDetailsData: {},
  containerDetailsLoading: false,
  containerDetailsError: null,

  containerNoLoading: false,
  containerNoData: null,
  containerNoError: null,

  containerStatusData: [],
  containerStatusLoading: false,
  containerStatusError: null,

  orderItemsListData: [],
  orderItemsListLoading: false,
  orderItemsListError: null,

  assignLoading: false,
  assignError: null,

  unAssignLoading: false,
  unAssignError: null,

  splitContainerItemLoading: false,
  splitContainerItemError: null,

  reverseSplitContainerItemLoading: false,
  reverseSplitContainerItemError: null,

  containerChangeStatusLoading: false,
  containerChangeStatusError: null,

  // Delete Items
  deleteContainerItemLoading: false,
  deleteContainerItemError: null,
};

// 🔹 Get Containers
export const getContainer = createAsyncThunk(
  "containers/getContainer",
  async (data, thunkAPI) => {
    try {
      return await fetchContainer(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Get Containers Details
export const getContainerDetails = createAsyncThunk(
  "containers/getContainerDetails",
  async (data, thunkAPI) => {
    try {
      return await fetchContainerDetails(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Get Container Status
export const getContainerStatus = createAsyncThunk(
  "orders/getContainerStatus",
  async (data, thunkAPI) => {
    try {
      return await fetchContainerStatus(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);

// 🔹 Get order items list
export const getOrderItemsList = createAsyncThunk(
  "orders/getOrderItemsList",
  async (data, thunkAPI) => {
    try {
      return await fetchOrderItems(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Create Containers
export const addContainer = createAsyncThunk(
  "containers/addContainer",
  async (data, thunkAPI) => {
    try {
      return await createContainer(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Edit Containers
export const editContainer = createAsyncThunk(
  "containers/editContainer",
  async (data, thunkAPI) => {
    try {
      return await updateContainer(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 assign items
export const assignItem = createAsyncThunk(
  "containers/assignItem",
  async (data, thunkAPI) => {
    try {
      return await assignitemApi(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);

// 🔹 assign items
export const unAssignItem = createAsyncThunk(
  "containers/unAssignItem",
  async (data, thunkAPI) => {
    try {
      return await unassignitemApi(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 split items
export const splitContainerItem = createAsyncThunk(
  "containers/splitContainerItem",
  async (data, thunkAPI) => {
    try {
      return await splitContainerItemApi(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 reverse split items
export const reverseSplitContainerItem = createAsyncThunk(
  "containers/reverseSplitContainerItem",
  async (data, thunkAPI) => {
    try {
      return await reverseSplitContainerItemApi(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Create Containers No
export const generatorContainerNo = createAsyncThunk(
  "containers/generatorContainerNo",
  async (data, thunkAPI) => {
    try {
      return await createContainerNo(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);
// 🔹 Create Containers items
export const addContainerItems = createAsyncThunk(
  "containers/addContainerItems",
  async (data, thunkAPI) => {
    try {
      return await addItemsContainer(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);

// 🔹 Change Status
export const changeContainerStatus = createAsyncThunk(
  "orders/changeContainerStatus",
  async (userData, thunkAPI) => {
    try {
      const response = await changeContainerStatusApi(userData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);

// 🔹 Delete Items
export const deleteContainerItem = createAsyncThunk(
  "orders/deleteContainerItem",
  async (data, thunkAPI) => {
    try {
      return await deleteContainerItemApi(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(extractApiError(error));
    }
  }
);

const containerSlice = createSlice({
  name: "containers",
  initialState,
  reducers: {
    resetContainerData: (state) => {
      state.containerLoading = false;
      state.containerError = null;
      state.containerData = {};
    },
    resetContainerNoData: (state) => {
      state.containerNoData = null;
      state.containerNoError = null;
      state.containerNoLoading = false;
    },
    resetOrderItemsNoData: (state) => {
      state.orderItemsListData = [];
      state.orderItemsListLoading = false;
      state.orderItemsListError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContainer.pending, (state) => {
        state.containerLoading = true;
        state.containerError = null;
      })
      .addCase(getContainer.fulfilled, (state, action) => {
        state.containerLoading = false;
        state.containerError = null;
        state.containerData = action.payload;
      })
      .addCase(getContainer.rejected, (state, action) => {
        state.containerLoading = false;
        state.containerError = action.payload;
      });
    // ➕ GET CONTAINER DETAILS
    builder
      .addCase(getContainerDetails.pending, (state) => {
        state.containerDetailsLoading = true;
        state.containerDetailsError = null;
      })
      .addCase(getContainerDetails.fulfilled, (state, action) => {
        state.containerDetailsLoading = false;
        state.containerDetailsError = null;
        state.containerDetailsData = action.payload.data;
      })
      .addCase(getContainerDetails.rejected, (state, action) => {
        state.containerDetailsLoading = false;
        state.containerDetailsError = action.payload;
      });
    // ➕  CONTAINER STATUS LIST
    builder
      .addCase(getContainerStatus.pending, (state) => {
        state.containerStatusLoading = true;
        state.containerStatusError = null;
      })
      .addCase(getContainerStatus.fulfilled, (state, action) => {
        state.containerStatusLoading = false;
        state.containerStatusError = null;
        state.containerStatusData = action.payload.data;
      })
      .addCase(getContainerStatus.rejected, (state, action) => {
        state.containerStatusLoading = false;
        state.containerStatusError = action.payload;
      });
    // GET ORDER ITEMS LIST
    builder
      .addCase(getOrderItemsList.pending, (state) => {
        state.orderItemsListLoading = true;
        state.orderItemsListError = null;
      })
      .addCase(getOrderItemsList.fulfilled, (state, action) => {
        state.orderItemsListLoading = false;
        state.orderItemsListError = null;
        state.orderItemsListData = action.payload.data;
      })
      .addCase(getOrderItemsList.rejected, (state, action) => {
        state.orderItemsListLoading = false;
        state.orderItemsListError = action.payload;
      });
    // ➕ CREATE CONTAINER
    builder
      .addCase(addContainer.pending, (state) => {
        state.createLoading = true;
        state.createError = null;
      })
      .addCase(addContainer.fulfilled, (state) => {
        state.createLoading = false;
        showToast.success("Container created successfully!");
      })
      .addCase(addContainer.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = action.payload || "Failed to create container";
        showToast.error(state.createError);
      });
      // ➕ EDIT CONTAINER
    builder
      .addCase(editContainer.pending, (state) => {
        state.editLoading = true;
        state.editError = null;
      })
      .addCase(editContainer.fulfilled, (state) => {
        state.editLoading = false;
        showToast.success("Container Edit successfully!");
      })
      .addCase(editContainer.rejected, (state, action) => {
        state.editLoading = false;
        state.editError = action.payload || "Failed to edit container";
        showToast.error(state.editError);
      });
    // ➕ CREATE CONTAINER NO
    builder
      .addCase(generatorContainerNo.pending, (state) => {
        state.containerNoLoading = true;
        state.containerNoError = null;
      })
      .addCase(generatorContainerNo.fulfilled, (state, action) => {
        state.containerNoLoading = false;
        state.containerNoError = null;
        state.containerNoData = action.payload.data;
      })
      .addCase(generatorContainerNo.rejected, (state, action) => {
        state.containerNoLoading = false;
        state.containerNoError = action.payload || "Failed to create container";
        showToast.error(state.containerNoError);
      });
    // ➕ ADD CONTAINER ITEMS
    builder
      .addCase(addContainerItems.pending, (state) => {
        state.addContainerLoading = true;
        state.addContainerError = null;
      })
      .addCase(addContainerItems.fulfilled, (state) => {
        state.addContainerLoading = false;
        showToast.success("Add items successfully!");
      })
      .addCase(addContainerItems.rejected, (state, action) => {
        state.addContainerLoading = false;
        state.addContainerError = action.payload || "Failed to add items";
        showToast.error(state.addContainerError);
      });
    // 🗑️ DELETE CONTAINER ITEM
    builder
      .addCase(deleteContainerItem.pending, (state) => {
        state.deleteContainerItemLoading = true;
        state.deleteContainerItemError = null;
      })
      .addCase(deleteContainerItem.fulfilled, (state) => {
        state.deleteContainerItemLoading = false;
        showToast.success("Item deleted successfully.");
      })
      .addCase(deleteContainerItem.rejected, (state, action) => {
        state.deleteContainerItemLoading = false;
        state.deleteContainerItemError =
          action.payload || "Failed to delete item";
        showToast.error(state.deleteContainerItemError);
      });
    // ➕ ASSIGN ITEMS
    builder
      .addCase(assignItem.pending, (state) => {
        state.assignLoading = true;
        state.assignError = null;
      })
      .addCase(assignItem.fulfilled, (state) => {
        state.assignLoading = false;
        showToast.success("Item assigned successfully!");
      })
      .addCase(assignItem.rejected, (state, action) => {
        state.assignLoading = false;
        state.assignError = action.payload || "Failed to assigned item";
        showToast.error(state.assignError);
      });
    // ➕ ASSIGN ITEMS
    builder
      .addCase(unAssignItem.pending, (state) => {
        state.unAssignLoading = true;
        state.unAssignError = null;
      })
      .addCase(unAssignItem.fulfilled, (state) => {
        state.unAssignLoading = false;
        showToast.success("Item unassigned successfully!");
      })
      .addCase(unAssignItem.rejected, (state, action) => {
        state.unAssignLoading = false;
        state.unAssignError = action.payload || "Failed to unassigned item";
        showToast.error(state.unAssignError);
      });
    //  SPLIT ITEMS
    builder
      .addCase(splitContainerItem.pending, (state) => {
        state.splitContainerItemLoading = true;
        state.splitContainerItemError = null;
      })
      .addCase(splitContainerItem.fulfilled, (state) => {
        state.splitContainerItemLoading = false;
        showToast.success("Container item split successfully!");
      })
      .addCase(splitContainerItem.rejected, (state, action) => {
        state.splitContainerItemLoading = false;
        state.splitContainerItemError =
          action.payload || "Failed to split item";
        showToast.error(state.splitContainerItemError);
      });
    // REVERSE SPLIT ITEM
    builder
      .addCase(reverseSplitContainerItem.pending, (state) => {
        state.reverseSplitContainerItemLoading = true;
        state.reverseSplitContainerItemError = null;
      })
      .addCase(reverseSplitContainerItem.fulfilled, (state) => {
        state.reverseSplitContainerItemLoading = false;
        showToast.success("Container item reversed successfully!");
      })
      .addCase(reverseSplitContainerItem.rejected, (state, action) => {
        state.reverseSplitContainerItemLoading = false;
        state.reverseSplitContainerItemError =
          action.payload || "Failed to reversed item";
        showToast.error(state.reverseSplitContainerItemError);
      });
    // ✏️ CHANGE CONTAINER STATUS
    builder
      .addCase(changeContainerStatus.pending, (state) => {
        state.containerChangeStatusLoading = true;
        state.containerChangeStatusError = null;
      })
      .addCase(changeContainerStatus.fulfilled, (state) => {
        state.containerChangeStatusLoading = false;
      })
      .addCase(changeContainerStatus.rejected, (state, action) => {
        state.containerChangeStatusLoading = false;
        state.containerChangeStatusError =
          action.payload || "Failed to Order placed";
        showToast.error(state.containerChangeStatusError);
      });
  },
});
export const {
  resetContainerNoData,
  resetOrderItemsNoData,
  resetContainerData,
} = containerSlice.actions;
export default containerSlice.reducer;
